import * as React from "react"

import { cn } from "@/lib/utils"

/**
 * Shadcn-style wrapped <input>.
 *
 * Behaviour tweak: for `type="number"` we disable mouse-wheel scrolling so the
 * value cannot be accidentally incremented/decremented when the user scrolls
 * the page while the input is focused (classic UX pitfall on forms with
 * monetary / superficie / anno fields). Implemented by blurring the input on
 * wheel events — this lets the page scroll normally without touching the value
 * and keeps default keyboard behaviour (arrow keys still work).
 */
const Input = React.forwardRef(({ className, type, onWheel, ...props }, ref) => {
  const handleWheel = (e) => {
    if (type === "number") {
      // Dropping focus is more reliable than preventDefault() because React
      // registers wheel listeners as passive by default.
      e.currentTarget.blur();
    }
    if (onWheel) onWheel(e);
  };
  return (
    <input
      type={type}
      onWheel={handleWheel}
      className={cn(
        "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Input.displayName = "Input"

export { Input }
